<template>
  <div class="app-container member-list">
    <div class="member-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="member-list-filter-value" v-model.trim="search.nickname" @keyup.enter.native="searchChange" placeholder="官方号名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <!-- <div class="grid-content bg-purple">
            <el-select class="member-list-filter-location-value" placeholder="官方号等级" v-model="search.tierId" size="small" clearable>
               <el-option
                v-for="item in accountTierOptions"
                :key="item.tierId"
                :label="item.officialName"
                :value="item.tierId">
              </el-option>
            </el-select>
          </div> -->
        </el-col>
        <el-col :span="12">
          <div>
            <el-button class="member-list-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="member-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <basic-container class="member-list-container">
      <avue-crud ref="crud"
                 :option="tableOption"
                 :data="list"
                 :page="page"
                 :table-loading="listLoading"
                 :before-open="handleOpenBefore"
                 @current-change="handleCurrentChange"
                 @refresh-change="handleRefreshChange"
                 @size-change="handleSizeChange">
          <template slot-scope="scope" slot="avatar">
              <div class="admin-image">
                <img class="image" :src="scope.row.avatar">
              </div>
          </template>

        <template slot="menuLeft">
          <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" v-if="permissions.official_member_add">新增</el-button>
        </template>

        <template slot="postCount"
                  slot-scope="scope">
          {{scope.row.postCount}}
        </template>

        <template slot="columnOpenedCount"
                  slot-scope="scope">
          <a href="javascript:void(0);" @click="toColumnList(scope.row.memberId);"
              class="member-list-container-button">
            {{scope.row.columnOpenedCount}}</a>
        </template>

        <template slot="commentCount"
                  slot-scope="scope">
            {{scope.row.commentCount}}
        </template>

        <template slot="menu"
                  slot-scope="scope">
          <el-button size="mini"
                    type="text"
                    icon="el-icon-view"
                    @click="handleView(scope.row,scope.index)">查看
          </el-button>
          <el-button size="mini"
                    type="text"
                    icon="el-icon-edit"
                    v-if="permissions.official_member_edit"
                    @click="handleEdit(scope.row,scope.index)">编辑
          </el-button>
        </template>
      </avue-crud>
    </basic-container>

  </div>
</template>

<script>
  import { fetchList } from '@/api/admin/member'
  import MemberTypeEnum from '@/common/enums/MemberTypeEnum'
  import {officialTableOption} from '@/const/crud/admin/member'
  import {mapGetters} from "vuex";
  import anonymousImage from '@/static/images/member/anonymous.svg';
  import { fetchAccountTierList } from '@/api/admin/tier'

  export default {
    name: "table_member",
    data() {
      return {
        // 搜索功能
        search: {
          current: 1,
          size: 10,
          nickname: "",
          tierId: null
        },
        accountTierOptions: [],
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 10, // 每页显示多少条,
        },
        list: [],
        tableOption: officialTableOption,
        listLoading: false,
      };
    },
    activated () {
      this.initPage()
      this.queryMembers()
    },
    async created() {
      await this.initPage()
      await this.loadAccountTierOptions()
      await this.queryMembers()
    },
    computed: {
      ...mapGetters(['permissions']),
    },
    methods: {
      formatData(records) {
        let _this = this
        if (records && records.length > 0) {
          records.forEach(function(record, index) {
            if (!record.nickname) { record.nickname = "--" }
            if (!record.avatar) { record.avatar = anonymousImage }
            if (!record.relatedPersonalRealname) { record.relatedPersonalRealname = "--"}
            if (!record.postCount) { record.postCount = 0 }  // 帖子量
            record.officialTierName = _this.accountTierOptions.find(item => item.tierId === record.tierId).officialName
          })
        }
        return records
      },
      getList() {
        // 获取会员列表
        let params = {
          current: this.search.current,
          size: this.search.size,
          memberType: MemberTypeEnum.ENTERPRISE.name,
          sortField: "inserted_time",
          sortPolicy: "desc"
        }
        // 增加搜索功能
        // 昵称
        if (this.search.nickname != "" && this.search.nickname.trim() != "")
          params.nickname = this.search.nickname
        // 账号等级
        if (this.search.tierId != null)
          params.tierId = this.search.tierId

        this.listLoading = true
        fetchList(params).then(response => {
          this.list = this.formatData(response.data.data.records)
          this.page.total = response.data.data.total
          this.listLoading = false
        });
      },
      initPage() {
        this.page.currentPage = 1
        this.page.pageSize = this.search.size
        this.search.current = 1
      },
      searchChange() {
        this.initPage()
        this.getList()
      },
      searchReset() {
        this.search.nickname = ""
        this.search.phoneNumber = ""
        this.search.province = ""
        this.search.city = ""
        this.search.company = ""
        this.search.industry = ""
        this.search.isBanned = null
        this.search.isActive = null
        this.search.searchTime = []
        this.search.tierId = null
        this.searchChange()
      },
      // 页码发生变化
      handleCurrentChange(val) {
        this.page.currentPage = val
        this.search.current = val
        this.getList()
      },
      // 刷新
      handleRefreshChange() {
        this.getList()
      },
      // 页面展示数据条数发生变化
      handleSizeChange(val) {
        this.page.pageSize = val
        this.page.currentPage = 1
        this.search.size = val
        this.search.current = 1
        this.getList()
      },
      handleOpenBefore(show, type) {
        show();
      },
      handleView(row, index) {
        this.$router.push({
          path: `/upms/member/official/detail/${row.memberId}`
        })
      },
      handleEdit(row, index) {
        this.$router.push({
          path: `/upms/member/official/edit/${row.memberId}`
        })
      },
      queryMembers() {
        if (this.$route.query.date !== undefined) {
            this.search.searchTime.push(this.$route.query.date, this.$route.query.date)
        }
        this.getList()
      },
      handleAdd: function() {
        this.$router.push({
          path: '/upms/member/add'
        })
      },
      async loadAccountTierOptions() {
        await fetchAccountTierList().then(response => {
          this.accountTierOptions = response.data.data;
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
.admin-image {
  width: 100%;
  max-width: 100px;
  height: 100%;
  max-height: 100px
}
.image {
  width: 50px;
  height: 50px;
  border-radius:50px;
}
.member-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-empty {
      display: block;
    }
    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }
    &-value {
      width: calc(100% - 12px) !important;
    }
    &-location-value {
      width: calc(100% - 12px) !important;
      input {
        border: none !important;
      }
    }
    &-date {
      width: 96%!important;
    }
    &-search {
      float: right;
      margin-right: 10px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
  &-container {
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
  }
}
</style>
